var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Fragment',_vm._l((_vm.currentData),function(value,key){return _c('EventsDowCard',{key:key,staticClass:"span-4",attrs:{"title":_vm.EVENT_TO_LABEL[key] || key,"data":value}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }